import { render, staticRenderFns } from "./EditTitleBar.vue?vue&type=template&id=c928da18"
import script from "./EditTitleBar.vue?vue&type=script&lang=ts"
export * from "./EditTitleBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports